import axios from "axios";

// Storage key for admin token
const STORAGE_TOKEN_KEY = "admin_token";

// Add a request interceptor to include the token in all requests
axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem(STORAGE_TOKEN_KEY);
    
    if (token && config.headers) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add a response interceptor to handle 401 errors (invalid/expired tokens)
axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      // Token is invalid or expired, clear it
      localStorage.removeItem(STORAGE_TOKEN_KEY);
      // Optionally, you could redirect to login page or trigger a re-login
      // For now, we'll just clear the token and let the user see the login dialog
    }
    return Promise.reject(error);
  }
);

export default axios;
